import { useState } from 'react';
import { Button, Col, Form, Row, Container, Spinner } from "react-bootstrap";

function ModificacionProductos(props) {
    const { datos, setShowModal, listProductosCargados } = props;

    // Para guardar los datos del formulario
    const [formData, setFormData] = useState(initialFormData(datos));

    const { cantidad } = datos;

    // Cancelar y cerrar el formulario
    const cancelarRegistro = () => {
        setShowModal(false)
    }

    // Para controlar la animacion
    const [loading, setLoading] = useState(false);

    function cambiarValor(valorABuscar, valorViejo, valorNuevo) {
        listProductosCargados.forEach(function (elemento) { // recorremos el array

            //asignamos el valor del elemento dependiendo del valor a buscar, validamos que el valor sea el mismo y se reemplaza con el nuevo. 
            elemento[valorABuscar] = elemento[valorABuscar] == valorViejo ? valorNuevo : elemento[valorABuscar]
        })
    }

    const addItems = () => {

        setLoading(true);

        cambiarValor("cantidad", datos.cantidad, formData.cantidad);

        cancelarRegistro();
    }

    const onChange = e => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    return (
        <>
            <Container fluid>
                <div className="formularioDatos">
                    <Form onChange={onChange}>
                        <Row>
                            <Form.Group as={Col} controlId="formGridCliente">
                                <Form.Label>
                                    Cantidad
                                </Form.Label>
                                <Form.Control
                                    id="cantidad"
                                    type="text"
                                    defaultValue={formData.cantidad}
                                    name="cantidad"
                                />
                            </Form.Group>
                        </Row>

                        <br />
                        <Form.Group as={Row} className="botones">
                            <Col>
                                <Button
                                    title="Actualizar el registro"
                                    variant="success"
                                    className="registrar"
                                    onClick={() => {
                                        addItems()
                                    }}
                                >
                                    {!loading ? "Modificar" : <Spinner animation="border" />}
                                </Button>
                            </Col>
                        </Form.Group>
                    </Form>
                </div>
            </Container>
        </>
    );
}

function initialFormData(data) {

    return {
        cantidad: data.cantidad,
        um: data.um,
        precioUnitario: data.precioUnitario,
        total: data.total
    }
}

export default ModificacionProductos;